import { CssSpace } from '@xbcb/ui-types';
import styled from 'styled-components';

export const StyledObjectIconImg = styled.img<{ $height?: number }>`
  transition: stroke 0.3s ease, fill 0.3s ease;
  height: ${({ $height }) => ($height ? `${$height}px` : CssSpace.SPACE_5)};
`;
